import { ChatComponent } from './chat/chat.component';
import { ChatFlowService } from './services/chat.flow.service';

export const FLOW_STATES: any[] = [
    {
        name: 'home.project.summary.flow',
        url: '/flow/:topicId',
        data: { collapseFooter: true },
        params: {
            topicId: { value: null, squash: true, dynamic: true }
        },
        resolve: [
            {
                token: 'aiSettings',
                deps: [ChatFlowService, 'project'],
                resolveFn: (chatFlowService: ChatFlowService, project: any) =>
                    chatFlowService.getAiSettings(project.id)
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ChatComponent
            }
        }
    }
];
